import React, { useState, useEffect, useContext } from 'react';
import { Button, Dialog } from '@material-ui/core';

import StripeCardElement from 'components/StripeCardElement';

import ReplayTwoToneIcon from '@material-ui/icons/ReplayTwoTone';
import CreditCardTwoToneIcon from '@material-ui/icons/CreditCardTwoTone';

import { CircularProgressContext } from 'components/CircularProgressOverlay';
import { NotificationContext } from 'components/NotificationOverlay';

import { cleanPhone } from 'utils/text';
import { reservationService, isLoggedIn, getLoggedInUser, setLoggedInUser, logout } from 'services/reservationService';
import { paymentService } from 'services/paymentService';

import { DialogTitleContainer, DialogContentContainer, DialogActionsContainer } from './style';

import 'react-credit-cards/es/styles-compiled.css';

const AddCardModal = ({ modalOpen, passengerDetail, handleModalClose }) => {
  const [stripeClientSecret, setStripeClientSecret] = useState(null);
  const { showCircularProgress, hideCircularProgress } = useContext(CircularProgressContext);
  const { showNotification } = useContext(NotificationContext);

  const getStripeIntents = async () => {
    showCircularProgress('Reading Card on File...');
    const data = await paymentService.get_stripe_customer_intent({
      passenger_id: passengerDetail.id,
    });
    hideCircularProgress();

    if (data.data.status === 'SUCCESS') {
      setStripeClientSecret(data.data.data.client_secret);
    }
  };

  useEffect(() => {
    if (modalOpen && passengerDetail) {
      getStripeIntents();
    }
  }, [modalOpen]);

  const handleAddStripePayment = async token => {
    if (token) {
      showCircularProgress('Please wait. Saving Payment Method...');
      const data = await paymentService.add_stripe_payment_to_passenger({
        fname: passengerDetail.fname,
        lname: passengerDetail.lname,
        email: passengerDetail.email,
        phone: cleanPhone(passengerDetail.phone1),
        token_val: token?.id,
      });
      hideCircularProgress();
      if (data.data.status === 'SUCCESS') {
        showNotification('Successfully saved', 'success');
        handleModalClose(true);
        const data1 = await reservationService.login_token_check();
        if (data1 && data1?.data?.status === 'FAIL') {
          logout();
        } else {
          setLoggedInUser({ ...getLoggedInUser(), ...data1.data.data });
        }
      } else {
        showNotification(`Sorry, Failed to add card: ${data.data.data.msg}`, 'error');
      }
    }
  };

  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      open={modalOpen && isLoggedIn()}
      onClose={handleModalClose}
      closeable
      disableBackdropClick
      disableEscapeKeyDown
    >
      <DialogTitleContainer>
        <CreditCardTwoToneIcon fontSize="small" /> <span>Card On File</span>
      </DialogTitleContainer>
      <DialogContentContainer className="p-0" dividers>
        <div className="dialog-content--wrapper card-dialog--wrapper border-0">
          <div className="card-body px-lg-4 py-lg-3">
            <div className="card-body--column w-100">
              <StripeCardElement
                accountId={null}
                options={stripeClientSecret ? { clientSecret: stripeClientSecret } : null}
                handleUpdateStripePayment={handleAddStripePayment}
              />
            </div>
          </div>
        </div>
      </DialogContentContainer>
      <DialogActionsContainer className="p-3">
        <Button variant="contained" className="btn-warning btn-transition-none" fullWidth onClick={handleModalClose}>
          <span className="btn-wrapper--icon">
            <ReplayTwoToneIcon fontSize="small" />
          </span>
          <span className="btn-wrapper--label">Close</span>
        </Button>
      </DialogActionsContainer>
    </Dialog>
  );
};

export default AddCardModal;
